import styled from 'styled-components';
import { Input } from './Input.styled';
import { Popover } from './Popover.styled';

export const TextInput = styled(Input)<{ $width?: number }>`
    width: ${(props) => (props.$width ? `${props.$width}px !important` : 'auto')};
`;

export const AutocompleteDropdown = styled(Popover)<{ $width?: number }>`
    width: ${(props) => (props.$width ? `${props.$width}px !important` : 'auto')};
    z-index: 1000;
    margin-top: 73px;
    white-space: nowrap;
    min-width: revert;
`;
export const AutocompleteItem = styled.li`
    position: relative;
    display: block;
    width: 100%;
    border-bottom: 1px solid gray;
    padding: 12px;
    cursor: pointer;
`;
